import React, { FunctionComponent } from 'react';
import { faEnvelope, faSms, faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHasPremiumPlan } from 'hooks/premiumPlan';
import styles from './Channel.module.scss';

interface ChannelProps {
    selectedChannel: 'email' | 'sms';
    onChannelChange: (channel: 'email' | 'sms') => void;
}

export const Channel: FunctionComponent<ChannelProps> = ({ selectedChannel, onChannelChange }) => {
    const hasPremiumPlan = useHasPremiumPlan();

    const handleChannelChange = (channel: 'email' | 'sms') => {
        // Si es SMS y no tiene premium, no permitir el cambio
        if (channel === 'sms' && !hasPremiumPlan) {
            return;
        }
        onChannelChange(channel);
    };

    return (
        <div className={styles.channelGroup}>
            <h3 className={styles.title}>Channel</h3>
            <div className={styles.channelOptions}>
                <div className={styles.channelGrid}>
                    <button
                        className={`${styles.radioOption} ${selectedChannel === 'email' ? styles.active : ''}`}
                        onClick={() => handleChannelChange('email')}
                        type="button"
                    >
                        <div
                            className={`${styles.radioOptionInput} ${selectedChannel === 'email' ? styles.active : ''}`}
                        >
                            <FontAwesomeIcon icon={faCheck} />
                        </div>
                        <FontAwesomeIcon
                            icon={faEnvelope}
                            className={styles.channelIcon}
                        />
                        <span className={styles.channelLabel}>Email</span>
                    </button>
                </div>
                <div className={styles.channelGrid}>
                    <button
                        className={`${styles.radioOption} ${selectedChannel === 'sms' ? styles.active : ''} ${
                            !hasPremiumPlan ? styles.disabled : ''
                        }`}
                        onClick={() => handleChannelChange('sms')}
                        type="button"
                        disabled={!hasPremiumPlan}
                    >
                        <div className={`${styles.radioOptionInput} ${selectedChannel === 'sms' ? styles.active : ''}`}>
                            <FontAwesomeIcon icon={faCheck} />
                        </div>
                        <FontAwesomeIcon
                            icon={faSms}
                            className={styles.channelIcon}
                        />
                        <span className={styles.channelLabel}>SMS</span>
                        {!hasPremiumPlan && <div className={styles.premiumLabel}>Premium</div>}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Channel;
